export default __webpack_public_path__ + "static/wish-you-were-here-mobile-58989937e09c1bac627a9800a1e40037.webp";